/**
 * 사용자 역할 유틸
 *
 * 계층: 제품 관리자 > 테넌트 관리자 > 고객사 관리자 > 팀 관리자 > 사용자
 * - productAdmin : 제품 관리자 (전체 권한)
 * - tenantAdmin  : 테넌트 관리자
 * - customerAdmin: 고객사 관리자 (고객사 단위 관리)
 * - teamAdmin    : 팀 관리자 (팀 단위 관리, 어드민 메뉴 접근 가능)
 * - user         : 일반 사용자
 *
 * ('admin' 은 레거시 값으로 productAdmin 으로 간주)
 */

export type UserRole = 'productAdmin' | 'tenantAdmin' | 'customerAdmin' | 'teamAdmin' | 'user';

/** 레거시 'admin' 값을 productAdmin 으로 정규화 */
export function normalizeRole(role: string | undefined | null): UserRole {
  if (role === 'admin' || role === 'productAdmin') return 'productAdmin';
  if (role === 'tenantAdmin') return 'tenantAdmin';
  if (role === 'customerAdmin') return 'customerAdmin';
  if (role === 'teamAdmin') return 'teamAdmin';
  return 'user';
}

/** 관리자(제품/테넌트/고객사/팀) 여부 */
export function isAdminRole(role: string | undefined | null): boolean {
  const r = normalizeRole(role);
  return r === 'productAdmin' || r === 'tenantAdmin' || r === 'customerAdmin' || r === 'teamAdmin';
}

/** 제품 관리자(전체 권한) 여부 */
export function isProductAdminRole(role: string | undefined | null): boolean {
  return normalizeRole(role) === 'productAdmin';
}

/** 테넌트 관리자 여부 */
export function isTenantAdminRole(role: string | undefined | null): boolean {
  return normalizeRole(role) === 'tenantAdmin';
}

/** 고객사 관리자 여부 */
export function isCustomerAdminRole(role: string | undefined | null): boolean {
  return normalizeRole(role) === 'customerAdmin';
}

/** 팀 관리자 여부 */
export function isTeamAdminRole(role: string | undefined | null): boolean {
  return normalizeRole(role) === 'teamAdmin';
}

/** 역할 표시 라벨 (한글) */
export function roleLabel(role: string | undefined | null): string {
  switch (normalizeRole(role)) {
    case 'productAdmin':
      return '제품 관리자';
    case 'tenantAdmin':
      return '테넌트 관리자';
    case 'customerAdmin':
      return '고객사 관리자';
    case 'teamAdmin':
      return '팀 관리자';
    default:
      return '사용자';
  }
}
